import { Tag } from './Tag';

/** Score badge for relevance 0-10. Uses theme's --score-* tokens. */
export function ScoreTag({ score }: { score: number | null | undefined }) {
  if (score == null) return <span className="text-subtle text-xs">—</span>;
  const variant = score >= 8 ? 'score-high' : score >= 4 ? 'score-mid' : 'score-low';
  return <Tag variant={variant}>{score}</Tag>;
}
